import * as universal from "../../../../src/routes/(app)/queue/+page.ts";
export { universal };
export { default as component } from "../../../../src/routes/(app)/queue/+page.svelte";